import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { hasConsent, subscribeConsent } from "@/lib/cookieConsent";

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

const GA_ID = "G-5ZFYNGQTPC";

/** Fires a GA4 page_view on every SPA route change. */
const GA4Tracker = () => {
  const location = useLocation();

  useEffect(() => {
    const sync = () => {
      if (!hasConsent("analytics") || typeof window.gtag !== "function") return;
      window.gtag("event", "page_view", { send_to: GA_ID, page_path: location.pathname + location.search, page_location: window.location.href, page_title: document.title });
    };
    sync();
    return subscribeConsent(sync);
  }, [location.pathname, location.search]);

  return null;
};

export default GA4Tracker;
